export default __webpack_public_path__ + "static/media/plus.71553a7c.png";